import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  dashboardContent: {},
  body: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    color: '#1C2541',
  },
  primaryColumn: {
    flex: 8,
    background: '#ffffff',
    width: '100%',
  },
  estateNameHeader: {
    lineHeight: '44px',
    fontSize: '32px',
    fontWeight: 700,
    marginTop: '14px',
    marginLeft: '14px',
  },
}));
